module.exports = __webpack_public_path__ + "static/media/direction.047f4ee5.svg";